import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import {
    PaginatedDynamicDataTable,
    Checkbox,
    Snackbar,
    VSpacer
} from 'sm-react-components';
import Typography from '@material-ui/core/Typography';

import ModalKey from '../modals/key';
import KeyDetails from '../views/KeyDetails';
import PageContainer from '../container/PageContainer';

import * as requests from '../../infrastructure/requests';
import * as routes from '../../infrastructure/routemap';
import * as formatters from '../formatters';
import Statistics from '../container/Statistics';
import UsageBillingPeriod from '../components/UsageBillingPeriod';
import UsageChart from '../components/charts/UsageChart';

const styles = {
    addButton: {
        position: 'absolute',
        bottom: '50px',
        right: '50px'
    },
    tabs: {
        boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
        marginBottom: '2px'
    },
    noKeys: {
        padding: '10px'
    }
};

class KeyManagement extends Component {
  state = {
      keyModal: false,
      newKeyId: undefined,
      showTestModal: false
  };

  handleKeyModalClose = id => {
      this.setState({ keyModal: false, newKeyId: id });
  };

  openKeyModal = () => {
      this.setState({ keyModal: true });
  };

  renderTestCheckbox = (val, item) => {
      return (
          <Checkbox
              checked={val}
              onClick={async event => {
                  event.stopPropagation();
                  const newItem = { id: item.id, testMode: !item.testMode };
                  try {
                      await requests.putKey(newItem);
                      item.testMode = newItem.testMode;
                      if (item.testMode) {
                          this.setState({ showTestModal: true });
                      } else {
                          this.setState(this.state);
                      }
                  } catch (error) {
                      console.log('There was an error fetching');
                  }
              }}
          />
      );
  };

  render() {
      const { keyModal, newKeyId, showTestModal } = this.state;
      const { classes, keyId } = this.props;
      return (
          <React.Fragment>
              {keyId === undefined && (
                  <React.Fragment>
                      <PageContainer noMinHeight>
                          {newKeyId && <Redirect to={`/console/keys/${newKeyId}`} />}
                          <PaginatedDynamicDataTable
                              provider={requests.getKeys}
                              mapping={[
                                  { column: 'name', name: 'Name', sortable: true },
                                  {
                                      column: 'key',
                                      name: 'Key',
                                      formatter: formatters.key,
                                      sortable: true
                                  },
                                  {
                                      column: 'created',
                                      name: 'Created',
                                      formatter: formatters.date,
                                      sortable: true
                                  },
                                  {
                                      column: 'testMode',
                                      name: 'Test',
                                      formatter: this.renderTestCheckbox,
                                      sortable: true
                                  },
                                  {
                                      column: 'tags',
                                      name: 'Tags',
                                      formatter: formatters.tags,
                                      sortable: true
                                  }
                              ]}
                              link={routes.console.key}
                              empty={
                                  <Typography className={classes.noKeys} variant="subtitle1">
                    No keys registered yet, create one with the button below.
                                  </Typography>
                              }
                              title="Keys"
                              tableActions={[
                                  { label: 'Create', actionCallback: this.openKeyModal }
                              ]}
                              search
                          />
                          <ModalKey open={keyModal} onClose={this.handleKeyModalClose} />
                      </PageContainer>
                      <VSpacer small />
                      <PageContainer noMinHeight>
                          <Typography variant="h2">Statistics</Typography>
                          <Statistics>
                              <UsageChart width={12} />
                          </Statistics>
                          <VSpacer medium />
                      </PageContainer>
                      <VSpacer small />
                      <PageContainer noMinHeight>
                          <Typography variant="h2">Usage</Typography>
                          <VSpacer medium />
                          <Typography>
                Total stops optimized including services + pickups
                          </Typography>
                          <VSpacer medium />
                          <UsageBillingPeriod />
                      </PageContainer>
                  </React.Fragment>
              )}
              {keyId !== undefined && (
                  <React.Fragment>
                      <KeyDetails id={keyId} />
                  </React.Fragment>
              )}
              <Snackbar
                  variant="info"
                  open={showTestModal}
                  onClose={() => this.setState({ showTestModal: false })}
                  autoHideDuration={10000}
                  closeByClickAway
                  horizontal="center"
                  vertical="bottom"
                  message="Test mode has been enabled. From now on, the requests performed with this key will return fake responses. You won't be charged for these requests. You can disable test mode at any time."
              />
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(KeyManagement);
